/**
 * Created by nijin on 14/3/17.
 */
import { Component, OnInit } from '@angular/core';
import {ThingsService} from "../things.service";
import {AuthService} from "../../auth/auth.service";

@Component({
    selector: 'nuc-qrcode',
    templateUrl: './qr-code.html',
    styleUrls:['./qr-code.scss']
})
export class QrCodeComponent implements OnInit {
     thing;
     thingSubject;
     isQrReady: boolean = false;
     qrString: string = '';
    constructor(private thingService: ThingsService,
        private authService: AuthService) { }

    ngOnInit() {
      this.thingSubject = this.thingService.getThingCreateSubject()
        .subscribe((response)=>{
        this.thing = response.thing;
        this.generateQrcode();
      });
    }

    generateQrcode(){
      this.isQrReady = true;
      this.qrString = `${this.thing.token}:${this.authService.getCurrentAccount().id}:${this.thing.name}`
    }

}



// WEBPACK FOOTER //
// ./src/app/things/onboard/qr-code.ts